module.exports = __webpack_public_path__ + "52cebac009baf5592e7d0ee53d8e45ed.woff2";